const SIDEBAR_MICRO_APP_SET = 'SIDEBAR_MICRO_APP_SET';
const SIDEBAR_MICRO_APP_REMOVE = 'SIDEBAR_MICRO_APP_REMOVE';

export {
  SIDEBAR_MICRO_APP_SET,
  SIDEBAR_MICRO_APP_REMOVE,
};
